import * as DropzoneModule from 'dropzone';
import type DropzoneType from 'dropzone';

export type { DropzoneOptions } from 'dropzone';

// dropzone@5 ships a webpack UMD/CJS bundle whose module.exports is
// `{ __esModule: true, default: Dropzone }`. Depending on the bundler's CJS
// interop (Vite 8 / Rolldown vs. Vitest), a default import may resolve to
// either the constructor or that wrapper object, so normalize it here.
function resolveDropzone(): typeof DropzoneType {
    let candidate: unknown = DropzoneModule;
    for (let i = 0; i < 3 && typeof candidate !== 'function'; i++) {
        candidate = (candidate as { default?: unknown } | undefined)?.default;
    }
    if (typeof candidate !== 'function') {
        throw new Error('Unable to resolve Dropzone constructor');
    }
    return candidate as typeof DropzoneType;
}

const Dropzone = resolveDropzone();
Dropzone.autoDiscover = false;

type Dropzone = DropzoneType;

export default Dropzone;
